// Full-screen "exactly what your customer sees" preview of the invoice.
// Shares InvoiceDocument with the public /i/:token route.
import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Loader2, Printer } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import InvoiceDocument from "./InvoiceDocument";

export default function InvoiceDocumentPreview({ open, onClose, invoiceId, saveNow }) {
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    if (!open || !invoiceId) return;
    let cancelled = false;
    setDoc(null);
    (async () => {
      try {
        if (saveNow) await saveNow();
        const { data } = await api.get(`/customer-invoices/${invoiceId}/document`);
        if (!cancelled) setDoc(data);
      } catch {
        toast.error("Preview failed");
        onClose?.();
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, invoiceId]);

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose?.(); }}>
      <DialogContent
        className="max-w-none w-[100vw] h-[100vh] sm:w-[96vw] sm:h-[94vh] p-0 rounded-none overflow-hidden bg-[#F2F1EF] flex flex-col gap-0"
        data-testid="invoice-document-preview">
        <DialogTitle className="sr-only">Customer invoice preview</DialogTitle>
        <div className="flex items-center justify-between gap-3 px-4 py-2.5 bg-[#09090B] text-white shrink-0">
          <div className="text-[11px] font-bold uppercase tracking-[0.16em]">
            Customer preview <span className="text-[#FF5F15]">— exactly what they see</span>
          </div>
          <div className="flex items-center gap-2 pr-8">
            <button onClick={() => window.print()} className="inline-flex items-center gap-1.5 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider border border-white/25 hover:border-white/60" data-testid="invoice-preview-print">
              <Printer className="w-3.5 h-3.5" /> Print
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto">
          {doc
            ? <InvoiceDocument doc={doc} preview onDownload={() => {}} />
            : <div className="h-full flex items-center justify-center py-24"><Loader2 className="w-7 h-7 animate-spin text-[#FF5F15]" /></div>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
